<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.19524 17.5067C7.11224 17.3927 6.10406 17.097 5.17068 16.6196C4.23731 16.1423 3.42506 15.5224 2.73393 14.76C2.04281 13.9976 1.49774 13.1248 1.09874 12.1416C0.699744 11.1583 0.500244 10.1109 0.500244 8.99944C0.500244 7.70269 0.760307 6.50569 1.28043 5.40844C1.80056 4.31119 2.50949 3.37069 3.40724 2.58694H1.35524V0.876938H6.48524V6.00694H4.77524V3.67706C3.99149 4.30406 3.36806 5.07713 2.90493 5.99625C2.44181 6.91538 2.21024 7.91644 2.21024 8.99944C2.21024 10.7522 2.78381 12.2663 3.93093 13.5416C5.07806 14.817 6.49949 15.5616 8.19524 15.7753V17.5067ZM7.83187 12.9324L4.21949 9.29869L5.41649 8.10169L7.83187 10.5171L12.684 5.66494L13.881 6.88331L7.83187 12.9324ZM11.6152 17.1219V11.9919H13.3252V14.3218C14.109 13.6806 14.7324 12.9039 15.1956 11.9919C15.6587 11.0799 15.8902 10.0824 15.8902 8.99944C15.8902 7.24669 15.3167 5.73263 14.1696 4.45725C13.0224 3.18187 11.601 2.43731 9.90524 2.22356V0.492188C12.0712 0.705938 13.8952 1.61794 15.3772 3.22819C16.8592 4.83844 17.6002 6.76219 17.6002 8.99944C17.6002 10.2962 17.3402 11.4932 16.8201 12.5904C16.2999 13.6877 15.591 14.6282 14.6932 15.4119H16.7452V17.1219H11.6152Z"
      :fill="clr ? clr : '#56606B'"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
